import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LoadScript from "vue-plugin-load-script";
import VueImg from 'v-img';
import VueI18n from 'vue-i18n'
import { langues } from './locales/langue';
import en from '@/locales/en.js';
import fr from '@/locales/fr.js';
import ar from '@/locales/ar.js';
// import i18n from './i18n';





// Liste des langues supportées avec leurs codes correspondants
const supportedLanguages = {
  EN: en,
  FR: fr,
  AR: ar
}

// Vérifie si une langue est déjà enregistrée dans le navigateur
const savedLanguage = localStorage.getItem('langue')

// Détecte la langue du navigateur
const browserLanguage = navigator.language.substr(0, 2).toUpperCase()

// Détermine la langue par défaut
let defaultLanguage = 'EN' // Langue par défaut si aucune détection

if (savedLanguage && supportedLanguages[savedLanguage]) {

  defaultLanguage = savedLanguage
} else if (supportedLanguages[browserLanguage]) {

  defaultLanguage = browserLanguage
}



const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: false,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: 'click',
  // Show thumbnails for all groups with more than 1 image
  thumbnails: false,
}
Vue.use(VueImg,vueImgConfig);
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: defaultLanguage,
  // fallbackLocale: 'FR',
  messages: {
    EN: en,
    FR: fr,
    AR: ar
  },
  silentTranslationWarn: process.env.NODE_ENV === 'production'
})

Vue.use(LoadScript);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n ,
  render: h => h(App),
  mounted() {

    this.$nextTick(async () => {

      // a utiliser si c'est delatrust.lu
      // await Vue.loadScript("/assets/js/jquery.js")
      // await Vue.loadScript("/assets/js/bootstrap.min.js")
      // await Vue.loadScript("/assets/js/jquery-ui.js")
      // await Vue.loadScript("/assets/js/jquery.fancybox.js")
      // await Vue.loadScript("/assets/js/owl.js")
      // await Vue.loadScript("/assets/js/appear.js")
      // await Vue.loadScript("/assets/js/wow.js")
      // await Vue.loadScript("/assets/js/scrollbar.js")
      // await Vue.loadScript("/assets/js/validate.js")
      await Vue.loadScript("/assets/js/paroller.js")
      await Vue.loadScript("/assets/js/custom-script.js")
      await Vue.loadScript("/assets/js/popper.min.js")
      await Vue.loadScript("/assets/js/isotope.js")
      const $ = window.$
      
      
    })
  }
}).$mount('#app')
